import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { useMemo } from "react";
import { User } from "../../../../domain/user/User";
import { UserId } from "../../../../domain/user/UserId";
import { UserEmail } from "../../../../domain/user/UserEmail";
import { UserName } from "../../../../domain/user/UserName";
import { getUserAccountRoleFromValue } from "../../../../domain/user/account/UserAccountRole";

export const useUserInformation = (): User | null => {
    const responseJson = useSelector((state: State) => state.adminUser.userInformation);

    const user = useMemo(() => (
        responseJson ? User.from(
            UserId.fromString(responseJson.id),
            UserName.fromString(responseJson.name),
            UserEmail.fromString(responseJson.email),
            getUserAccountRoleFromValue(responseJson.role)
        ) : null
    ), [responseJson]);

    return user;
};
